export const CSM_SERIAL_DEFAULT_BAUD_RATE = 230400
export const CSM_SERIAL_FILTER: SerialPortFilter = {
    usbVendorId: 0x0403,
    usbProductId: 0x6015
}